var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLicense(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "license") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 4,
    fill: "none",
    stroke: "currentColor",
    strokeLinejoin: "round",
    className: "nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49,3,24.525,27.375a17.112,17.112,0,1,0,12.1,12.1L41,35V27h8V19h8l4-4V3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 45.5,
    r: 5.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicense);
export default __webpack_public_path__ + "static/media/license.b31d446800cf5a9bc655e035c62af705.svg";
export { ForwardRef as ReactComponent };